import React, { useState, useEffect} from 'react'
import Datatable from './datatable-permitHolder'
import { SemipolarLoading  } from 'react-loadingg'
import { history } from '../../functions/_helpers'
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import TableMenu from './tableMenu'

const Franchises = (props) => {
   const [showEmptyTable,setShowEmptyTable] = useState(false)
   const [data, setData] = useState({ hits: [] });
   const [loading,setLoading] = useState(true);
   useEffect(() => {
      if (!loading && (props.franchises == null || props.franchises.length === 0)) {
         setShowEmptyTable(true);
      }
      else {
         setData(props.franchises);
         setShowEmptyTable(false);
      }
      setLoading(false);
   }, [props]);


   const editFranchise = function(id) {
      history.push('/franchiseEdit/' + id);
   }

   const deleteFranchise = function(id) {
      confirmAlert({
         title: '',
         message: 'Vil du slette franchisen?',
         buttons: [
            {
            label: 'Ja',
            onClick: () => doDelete(id)
            },
            {
            label: 'Nei',
            onClick: () => doNothing()
            }
         ]
      });
   }

   function doNothing(){
      history.push('/franchises');
   }

   function doDelete(id){
      props.onFranchiseDelete(id);
   }


   const columns = React.useMemo(
      () => [
         {
               Header: 'Navn',
               accessor: 'name'
         },
         {
               Header: 'E-post',
               accessor: 'email'
         },
         {
               Header: 'telefonnummer',
               accessor: 'phoneNumber'
         },
         {
               Header: 'Antall løyvehavere',
               accessor: 'permitHolders',
               Cell: props => (props.value ? props.value.length : 0)
         },
         {
               Header: '',
               accessor: 'franchiseId',
               Cell: props => <TableMenu id={props.value} editCb={editFranchise} deleteCb={deleteFranchise}/>
         }

      ],
      []
   )

   const items = JSON.stringify(data);

   if(typeof(data) === 'undefined' || items === null  || items.length <= 0 || items.length === undefined || data.length <= 0 || data.length ===undefined){
      if(!showEmptyTable){
         return <SemipolarLoading/>
      }
   }

   if (showEmptyTable) {
      return(<div><h3 style={{textAlign:"center",margin:"0 auto",color:"#4663ac"}}>Ingen franchiser funnet!</h3></div>)
   }


   return (
      <Datatable columns={columns} data={data} sortById={'franchiseId'} />
   )

}

export default Franchises
